import React from "react";
import { Text, TextProps } from "@chakra-ui/react";

export const QuestionLabel: React.FC<TextProps> = ({ children }) => (
	<Text fontWeight="bold" mt="20px">
		{children}
	</Text>
);
